import { Box, Text } from '@chakra-ui/react';
import React, { useEffect } from 'react';

import { useNavigate, useParams } from 'react-router-dom';
import { useAssessmentSubmission } from '../../../hooks/useAssessmentSumbission';
import { useAssessmentToken } from '../../../context/AssessmentTokenContext';
import { useAssessmentSubmissionBlockItem } from '../../../hooks/V2/useAssessmentSumbission';
import { useLocation } from 'react-router-dom';
const AssessTestIframe = () => {
	const { assessmentToken, assessmentId, redirectionPath } = useAssessmentToken();

	// if it is a course level assessment like Know Your Level
	const { publishedItemId } = useParams<{ publishedItemId: string }>();
	// if it is a block item level assessment like quiz, contest, badge contest
	const { blockItemId } = useParams<{ blockItemId: string }>();

	const navigate = useNavigate();

	const { data: userAssessmentPublishedItem } = useAssessmentSubmission(publishedItemId);
	const { data: userAssessmentBlockItem } = useAssessmentSubmissionBlockItem(blockItemId);

	const location = useLocation();
	const fullPath = location.pathname + location.search;

	useEffect(() => {
		if (!assessmentToken) {
			navigate(`/dashboard`);
		}
	}, [assessmentToken, navigate]);

	// TODO: Need to handle this
	useEffect(() => {
		window.addEventListener('message', e => {
			const data = e.data;
			if (data.type === 'assessment-ended') {
				window.location.href = redirectionPath;
			}
		});
		// get complete path with search params
	}, []);

	return (
		<>
			{assessmentToken ? (
				<Box w="100vw" h="100vh">
					<iframe
						title="Assessment"
						allow="camera; microphone; fullscreen; display-capture"
						style={{
							height: '100%',
							width: '100%',
						}}
						src={`${process.env.REACT_APP_ASSESS_PLATFORM_FRONTEND}test?token=${assessmentToken}`}
					></iframe>
				</Box>
			) : (
				<Box>
					<Text textStyle={'body1-md'}>Token not found</Text>
				</Box>
			)}
		</>
	);
};

export default AssessTestIframe;
